import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useMemo, useState } from "react";

type CurrentComponent = "visibility" | "sort" | "view" | "root";

const ControlsDropdownContext = createContext<{
  currentComponent: CurrentComponent;
  setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}>({
  currentComponent: "root",
  setCurrentComponent: () => {},
});

ControlsDropdownContext.displayName = "ControlsDropdownContext";

export const ControlsDropdownContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [currentComponent, setCurrentComponent] =
    useState<CurrentComponent>("root");

  const value = useMemo(
    () => ({ currentComponent, setCurrentComponent }),
    [currentComponent, setCurrentComponent],
  );
  return (
    <ControlsDropdownContext.Provider value={value}>
      {children}
    </ControlsDropdownContext.Provider>
  );
};

export const useControlsDropdownContext = () => {
  const context = useContext(ControlsDropdownContext);
  if (!context) {
    throw new Error(
      "useControlsDropdownContext must be used within a ControlsDropdownContextProvider",
    );
  }
  return context;
};
